<template>
  <el-col class="mb10" :xs="24" :sm="w100 ? 24 : 12" :md="w100 ? 24 : w50 ? 12 : 8">
    <div class="w100 flex-box al-c">
      <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }" v-if="typeData.label != ''">{{ typeData.label }}：</div>
      <div class="flex-1">
        <el-input clearable v-model="value" :placeholder="typeData.placeholder ? typeData.placeholder : '请输入' + typeData.label"></el-input>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "TextComp",
  props: ["type-data", "w50", "w100", "width"],
  components: {},
  data() {
    return {
      value: this.typeData.value ? this.typeData.value : ""
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>
